/**
 * @flow
 * @relayHash 3b4da85943e7e7aa38347ce95995093a
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type MediaFileStateType = "available" | "deleted" | "%future added value";
export type MediaFileTypeEnum = "image" | "live" | "video" | "wallpaper" | "%future added value";
export type MediaFileAddInput = {
  title?: ?string,
  description?: ?string,
  alt?: ?string,
  filename?: ?string,
  rating?: ?string,
  authors?: ?$ReadOnlyArray<?string>,
  type: MediaFileTypeEnum,
  status: string,
  preview?: ?string,
  topics?: ?$ReadOnlyArray<?string>,
  show?: ?string,
  slug?: ?string,
  seoTitle?: ?string,
  seoDescription?: ?string,
  seoKeywords?: ?string,
  state: MediaFileStateType,
  clientMutationId?: ?string,
};
export type MediaFileAddMutationVariables = {|
  input: MediaFileAddInput
|};
export type MediaFileAddMutationResponse = {|
  +MediaFileAdd: ?{|
    +mediaFileEdge: ?{|
      +node: ?{|
        +id: string
      |}
    |}
  |}
|};
export type MediaFileAddMutation = {|
  variables: MediaFileAddMutationVariables,
  response: MediaFileAddMutationResponse,
|};
*/


/*
mutation MediaFileAddMutation(
  $input: MediaFileAddInput!
) {
  MediaFileAdd(input: $input) {
    mediaFileEdge {
      node {
        id
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "MediaFileAddInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "MediaFileAdd",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "MediaFileAddInput!"
      }
    ],
    "concreteType": "MediaFileAddPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "mediaFileEdge",
        "storageKey": null,
        "args": null,
        "concreteType": "MediaFileEdge",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "MediaFile",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "MediaFileAddMutation",
  "id": null,
  "text": "mutation MediaFileAddMutation(\n  $input: MediaFileAddInput!\n) {\n  MediaFileAdd(input: $input) {\n    mediaFileEdge {\n      node {\n        id\n      }\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "MediaFileAddMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "MediaFileAddMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'aa74852a9c8d98e2875e2874e4ca613d';
module.exports = node;



// WEBPACK FOOTER //
// src/mutations/__generated__/MediaFileAddMutation.graphql.js